import { useEffect, useRef } from 'react';

import { useLocalStorage } from 'react-use';

import { Box } from '@mui/system';

import { ScaleAdsIcon } from '@/shared/assets/icons/ScaleAds';
import { IS_WHITE_LABEL } from '@/shared/environments';
import { redirectToScaleAdsSSO } from '@/shared/lib/scaleAdsSSO';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';
import { PromoBanner } from '@/shared/ui/PromoBanner';

const LS_SHOW_SCALE_ADS_BANNER_SIDEBAR = 'showScaleAdsBannerSidebar';

/**
 * Компонент баннера Scale Ads для продвижения создания видеорекламы
 * Использует PromoBanner с серой цветовой схемой
 */
export const ScaleAdsBannerSidebar = () => {
  const [show, setShowBanner] = useLocalStorage(LS_SHOW_SCALE_ADS_BANNER_SIDEBAR, true);

  const isFirstLoadRef = useRef<boolean>(false);

  /**
   * Обработчик закрытия баннера
   */
  const handleClose = () => {
    setShowBanner(false);
    MixpanelEvents.scaleAdsSidebarBannerClose();
  };

  /**
   * Обработчик клика по ссылке - перенаправляет на Scale Ads SSO
   */
  const handleSSORedirect = async (): Promise<void> => {
    MixpanelEvents.scaleAdsSidebarBannerClicked();
    await redirectToScaleAdsSSO();
  };

  const isShowBanner = show && !IS_WHITE_LABEL;

  useEffect(() => {
    if (isShowBanner && !isFirstLoadRef.current) {
      isFirstLoadRef.current = true;
    }
  }, [isShowBanner]);

  if (!isShowBanner) {
    return null;
  }

  return (
    <Box marginBottom={10} marginTop={10}>
      <PromoBanner
      title="Create video ads in minutes and boost your campaigns."
        link={{
          children: 'Create winning video ads',
          to: '#',
          onClick: handleSSORedirect,
        }}
        
        icon={<ScaleAdsIcon  height={16} width={16} />}
        onClose={handleClose}
      />
    </Box>
  );
};